import React, { Component } from 'react';
import PropTypes from 'prop-types';
import common from 'ui-react-common';

const { PasswordInput } = common.ui.components.forms;

export const validation = {
    validateOn: ['keyup'],
    required: true,
    minlength: 8,
    maxlength: 32,
    requirelower: true,
    requireupper: true,
    requirenumber: true,
    message: {
        default: 'Please enter a valid password',
    },
};

class Password extends Component {
    render() {
        return (
            <PasswordInput
                id="password"
                label={this.props.label}
                name="password"
                validation={validation}
            />
        );
    }
}

Password.defaultProps = {
    label: 'Create Password',
};

Password.propTypes = {
    label: PropTypes.string,
};

export default Password;
